import React from "react";

const Unauthorized401 = () => (
  <div className="account account--photo">
    <div className="account__wrapper">
      <div className="account__card">
        <div className="account__head">
          <h3 className="account__title">
            <span className="account__logo">
              401 - Lime
              <span className="account__logo-accent">Proxies</span>
            </span>
          </h3>
        </div>
        <h3 className="not-found__info">Unauthorized Access</h3>
      </div>
    </div>
  </div>
);

export default Unauthorized401;
